/*
 *
 * VetrinaDigitalePopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 04-Feb-2025
*/

import VetrinaDigitalePopup from './VetrinaDigitaleSubmitPopupContainer'

export default VetrinaDigitalePopup
